import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("omnia_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const acting = localStorage.getItem("omnia_acting_tenant");
  if (acting) config.headers["X-Acting-Tenant"] = acting;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Resolve a stored media reference to a displayable absolute URL.
// Relative "/api/uploads/..." paths are prefixed with the backend origin; full URLs pass through.
export function mediaUrl(u) {
  if (!u) return "";
  if (u.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${u}`;
  return u;
}

// Upload an image file, returns the relative url ("/api/uploads/file/...").
export async function uploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/uploads/image", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
}

// Upload any document (PDF/Office/image). Returns { url, path, filename }.
export async function uploadFile(file, priv = true) {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("private", priv ? "true" : "false");
  const { data } = await api.post("/uploads/file", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data;
}
